import { render, staticRenderFns } from "./EntityCreateEdit.vue?vue&type=template&id=875428e6"
import script from "./EntityCreateEdit.vue?vue&type=script&lang=js"
export * from "./EntityCreateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports